import algoliasearch from "algoliasearch/lite";

import myAxios from "../../utils/axiosWrapper";
import getConfig from "../../conf/config";
import { OPERATORS_FETCH, OPERATORS_FETCH_FAILURE, OPERATORS_FETCH_SUCCESS } from "../actionTypes";
import { auth } from "../../conf/firebase";

export const getOperatorsWithoutStore = async ({ start_date, end_date }) => {
  const { currentUser } = auth;
  if (!currentUser || currentUser === null) {
    const errorMessage = "Not fetching operators infos, user not authenticated";
    console.error(errorMessage);
    return;
  }

  const formattedStartDate = new Date(start_date).toISOString();
  const formattedEndDate = new Date(end_date).toISOString();

  const base_url = `${getConfig().API_URL}/audio/api/v1/operators`;

  const response = await myAxios.get(
    `${base_url}/?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
  );
  const { operators } = response.data[0];
  return operators;
};

// Fetch calls between start date and end date
export const getOperators = ({ start_date, end_date }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: OPERATORS_FETCH });
      const { currentUser } = auth;
      if (!currentUser || currentUser === null) {
        const errorMessage = "Not fetching algolia infos, user not authenticated";
        console.error(errorMessage);
        dispatch({
          type: OPERATORS_FETCH_FAILURE,
          payload: errorMessage,
        });
        return;
      }

      // Format dates using toISOString
      const formattedStartDate = new Date(start_date).toISOString();
      const formattedEndDate = new Date(end_date).toISOString();

      const base_url = `${getConfig().API_URL}/audio/api/v1/operators`;

      // Make Axios request to fetch calls data from the backend
      const response = await myAxios.get(
        `${base_url}/?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
      );
      const { operators } = response.data[0];

      // end
      dispatch({ type: OPERATORS_FETCH_SUCCESS, payload: operators });
    } catch (error) {
      console.log({ error });
      dispatch({ type: OPERATORS_FETCH_FAILURE, payload: error.message });
      throw error;
    }
  };
};

// Fetch operator infos between start date and end date
export const getOperatorInfo = ({ operator, start_date, end_date }) => {
  return async (dispatch, getState) => {
    const { currentUser } = auth;
    if (!currentUser || currentUser === null) {
      console.error("Not fetching operator info, user not authenticated");
      return;
    }
    try {
      dispatch({ type: OPERATORS_FETCH });
      const { operators } = getState().operators.operators;

      // Format dates using toISOString
      const formattedStartDate = new Date(start_date).toISOString();
      const formattedEndDate = new Date(end_date).toISOString();

      const base_url = `${getConfig().API_URL}/audio/api/v1/operators`;

      // Make Axios request to fetch calls data from the backend
      const promises = [
        myAxios.get(
          `${base_url}/${operator.id}/calls/?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        ),
        myAxios.get(
          `${base_url}/${operator.id}/grades/?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        ),
      ];
      const [operator_calls_response, operator_grades_response] = await Promise.all(promises);
      let operator_infos = {};
      if (operator_calls_response?.data[0]?.data) {
        operator_infos = { ...operator_infos, calls: operator_calls_response.data[0].data };
      }
      if (operator_grades_response?.data?.data) {
        operator_infos = { ...operator_infos, grades: operator_grades_response.data.data };
      }
      let updated_operators = operators.map((operator_item) =>
        operator_item.id === operator.id
          ? { ...operator_item, ...operator_infos, fetched_info: true }
          : operator_item
      );
      // end
      dispatch({ type: OPERATORS_FETCH_SUCCESS, payload: updated_operators });
    } catch (error) {
      console.log(error);
      dispatch({ type: OPERATORS_FETCH_FAILURE, payload: error.message });
      throw error;
    }
  };
};
